var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stores_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12750",
    transform: "translate(23012 13909)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-22972.4-13897.3h-33.9c-1,0-1.7-0.8-1.7-1.7v-1.7c0-3.8,3.1-6.9,6.9-6.9h23.5c3.8,0,6.9,3.1,6.9,6.9v1.7 C-22970.7-13898-22971.5-13897.3-22972.4-13897.3z M-23004.6-13900.7h30.4c0-1.9-1.6-3.5-3.5-3.5h-23.5 C-23003-13904.2-23004.6-13902.6-23004.6-13900.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-22972.4-13864.4h-33.9c-1,0-1.7-0.8-1.7-1.7v-26c0-1,0.8-1.7,1.7-1.7h33.9c1,0,1.7,0.8,1.7,1.7v26 C-22970.7-13865.1-22971.5-13864.4-22972.4-13864.4z M-23004.6-13867.8h30.4v-22.5h-30.4V-13867.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-22984.7-13864.4h-10.4c-1,0-1.7-0.8-1.7-1.7v-15.6c0-1.9,1.6-3.5,3.5-3.5h6.9c1.9,0,3.5,1.6,3.5,3.5v15.6 C-22982.9-13865.1-22983.7-13864.4-22984.7-13864.4z M-22993.3-13867.8h6.9v-13.9h-6.9L-22993.3-13867.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-22969.1-13890.3h-39.8c-1.9,0-3.5-1.6-3.5-3.5v-3.5c0-1.9,1.6-3.5,3.5-3.5h39.8c1.9,0,3.5,1.6,3.5,3.5v3.5 C-22965.6-13891.9-22967.2-13890.3-22969.1-13890.3z M-23008.9-13897.3L-23008.9-13897.3v3.5h39.8v-3.5H-23008.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStores);
export default __webpack_public_path__ + "static/media/Stores.d8c5c0f845cee7c32811429493e8c453.svg";
export { ForwardRef as ReactComponent };